import React from 'react';
import * as yup from "yup";
import {
    CostSupplierCategoriesQueryQuery,
    CostSupplierCategory, useCostSupplierCategoriesMutationMutation,
    useCostSupplierCategoriesQueryQuery,
} from '../../generated/graphql';

import {ListEditor} from '../../components/list-editor';
import {useLocation} from "react-router";

const schema =yup.array().of(
    yup.object().shape({
        'label': yup.string().required()
    }).required()
);

function blankCostSupplierCategory(): CostSupplierCategory {
    return {
        id: 'new',
        label: '',
    };
}

const columns = [{
    header: 'Name',
    accessor: 'label',
    dataType:'text',
}
];

function getValues(data:CostSupplierCategoriesQueryQuery) {
    return data?.costSupplierCategories?.data;
}


const CostSupplierCategories = () => {
    const url = useLocation().pathname;
    const query = useCostSupplierCategoriesQueryQuery();
    const [mutation,mutationResult] = useCostSupplierCategoriesMutationMutation();

    return (
        <ListEditor
            columns={columns}
            validationSchema={schema}
            title="Cost Supplier Categories"
            permission="costsuppliercategories"
            query={query}
            mutation={mutation}
            newRow={blankCostSupplierCategory}
            newRowLabel="Add Cost Supplier Category"
            baseUrl={url}
            className="cost-supplier-categories"
            getValues={getValues}
            saveResult={mutationResult}
        />);
}
export default CostSupplierCategories;